module.exports = __webpack_public_path__ + "static/img/Panel.03852641.svg";